import React from 'react'
import { Box, Flex, Text } from '@chakra-ui/core'

const WelcomeFooter = () => {
	return (
		<Box bg='brand.500'>
			<Flex direction='column' w='100%' h='100%' mx='auto' maxW='1280px' justify='center' px={[4, 4, 0]}>
				<Text fontSize='xs' color='white' py={1}>
					© 2020 VALID Certificadora Digital Ltda
					{/* – CLIQUE VALID e PRONTO! Uma empresa do grupo VALID S/A – CNPJ –
        14.121.957/0001-09 – Av. Paulista, 2.064 – 15o Andar – Cerqueira César – São Paulo/SP – 01.310-928 */}
				</Text>
			</Flex>
		</Box>
	)
}

export default WelcomeFooter
